module.exports = __webpack_public_path__ + "static/media/blog7.ca67afe9.jpg";